import { useEffect, useState } from 'react'
import api from '@/utils/api'
import analytics from '@/utils/analytics'
import { transcriptState, settingsState, isPremiumState } from '@/store'
import { useRecoilState } from 'recoil'

export default function useLoadTranscript({
  ytVideoId,
  isDemo,
  isEnabled = true,
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [settings] = useRecoilState(settingsState)
  const [transcript, setTranscript] = useRecoilState(transcriptState)
  const [isPremium] = useRecoilState(isPremiumState)

  useEffect(
    function loadTranscriptEffect() {
      async function loadTranscript() {
        try {
          const language = (settings && settings.transcriptLanguage) || 'en'
          analytics.track('Loading transcript')
          setIsLoading(true)
          const response = await api.get(
            `/transcript/${ytVideoId}?lang=${language}`
          )
          setTranscript(response.data)
        } catch (error) {
          analytics.track('Error loading transcript', { error })
          setTranscript([])
        } finally {
          setIsLoading(false)
        }
      }

      const userCanLoadTranscript = isPremium || isDemo

      if (!transcript && userCanLoadTranscript && isEnabled) {
        loadTranscript()
      }
    },
    [
      ytVideoId,
      isDemo,
      isPremium,
      settings,
      transcript,
      setTranscript,
      isEnabled,
    ]
  )

  return { isLoading, transcript }
}
